import { init } from '@rematch/core';
import models from './models';

// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: [''],
// };
const store = init({
  models,
  // plugins: [persistPlugin(persistConfig)],
});

export default store;
